export type DeclarationStatus = 'draft' | 'validated';

export const ABSENCE_REASONS = [
  'illness',
  'accident_occupational',
  'accident_non_occupational',
  'military_service',
  'maternity',
  'paternity',
  'unpaid',
  'unjustified',
] as const;

export type AbsenceReason = typeof ABSENCE_REASONS[number];

export const UNPAID_REASONS: AbsenceReason[] = ['unpaid', 'unjustified'];

export interface DeclarationQuantity {
  code: string;
  quantity: number;
}

export interface MonthlyDeclaration {
  id: string;
  id_company: string;
  id_employee: string;
  period: { year: number; month: number };
  as_days: number;
  absence_days: number;
  effective_working_days: number;
  quantities: DeclarationQuantity[];
  status: DeclarationStatus;
  validated_at?: string | null;
  validated_by?: string | null;
  notes?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface Absence {
  id: string;
  id_company: string;
  id_employee: string;
  reason: AbsenceReason;
  from: string;
  to?: string | null;
  incapacity_rate: number;
  salary_continuation_rate: number;
  notes?: string | null;
  is_deleted?: boolean;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface EligibleEmployee {
  id: string;
  employee_number: string;
  name: string;
  birth_date?: string | null;
  gender?: string | null;
  work_canton?: string | null;
  is_retroactive_only?: boolean;
  contract?: {
    salary_mode: 'monthly' | 'hourly';
    activity_rate?: number;
    hire_date?: string | null;
    end_date?: string | null;
    base_salary?: { amount: number; currency: string } | null;
  } | null;
  periodDays?: { worked: number; full: number } | null;
}

export interface ExcludedEmployee {
  id_employee: string;
  employee_number: string;
  name: string;
  reason: string;
  reason_detail?: string | null;
}

export interface EligibleEmployeesResponse {
  eligible: EligibleEmployee[];
  excluded: ExcludedEmployee[];
}

export type SalaryElementCalculation = 'fixed_amount' | 'quantity_rate' | 'percentage_of_base' | 'computed';

export interface SalaryElementType {
  code: string;
  name: Record<string, string>;
  category: string;
  calculation: SalaryElementCalculation;
  is_system?: boolean;
}

export interface PunctualRubrique {
  code: string;
  amount?: number | null;
  quantity?: number | null;
  rate?: number | null;
}
